import { ReactComponent as VisibilityFilled } from '../../../../assets/icons/visibility-filled.svg';

export { VisibilityFilled };
